module.exports = __webpack_public_path__ + "static/siderail2-cc0ccb8dbf28df0f2b9a09eed7bb2f8d.jpg";